'use client'

import { Icon } from "@/components/ui/icon"
import { Button } from "@heroui/react"

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function ArticlesError({ error, reset }: ErrorProps) {
  return (
    <div className="container px-4 py-8 mx-auto">
      <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
        <Icon icon="alert-triangle" className="w-12 h-12 text-danger" />
        <h2 className="text-xl font-semibold">Failed to Load Articles</h2>
        <p className="text-default-500">{error.message}</p>
        <Button onPress={reset}>
          Try again
        </Button>
      </div>
    </div>
  )
}
